/* Wholesale / corporate lead form. Posts the inquiry to the Wildgrain lead API,
   then hides the fields and shows the success message. Markup comes from
   snippets/wholesale-lead-form.liquid, so the page form and the Get in Touch
   modal share this behaviour. */
if (!customElements.get('wholesale-lead-form')) {
  class WholesaleLeadForm extends HTMLElement {
    connectedCallback() {
      if (this.form) return;

      this.endpoint = this.dataset.endpoint;
      this.eventName = this.dataset.eventName || 'wholesale_lead_submitted';
      this.formLocation = this.dataset.formLocation || 'wholesale_partnerships_page';
      this.form = this.querySelector('form');
      this.submitBtn = this.querySelector('[data-submit]');
      this.errorBox = this.querySelector('[data-error]');
      this.successBox = this.querySelector('[data-success]');

      if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    showError(message) {
      if (!this.errorBox) return;
      this.errorBox.textContent = message;
      this.errorBox.hidden = false;
    }

    clearError() {
      if (!this.errorBox) return;
      this.errorBox.hidden = true;
      this.errorBox.textContent = '';
    }

    setBusy(busy) {
      if (!this.submitBtn) return;
      this.submitBtn.setAttribute('aria-busy', busy ? 'true' : 'false');
      this.submitBtn.disabled = busy;
    }

    fireConversion() {
      // dataLayer push — for GA4 / GTM if a container is installed.
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: this.eventName,
          form_location: this.formLocation,
        });
      } catch (e) {}

      if (this.eventName === 'corporate_lead_submitted') this.fireMetaLead();
    }

    /* Meta "CorporateLead" custom event for corporate gifting enquiries (custom,
       not the standard Lead, so it never mixes with other lead tracking). The Meta pixel isn't on the
       storefront page itself (Littledata sends it server-side, GTM runs in
       Shopify's custom-pixel sandbox), so load the SDK just for this: autoConfig
       off and no PageView, so nothing else gets double-counted. Email/phone go
       in as advanced matching; fbq hashes them before sending. */
    fireMetaLead() {
      try {
        const PIXEL_ID = '226692614989214';
        const email = this.form.querySelector('input[type="email"]');
        const phone = this.form.querySelector('input[type="tel"]');
        const user = {};
        if (email && email.value) user.em = email.value.trim().toLowerCase();
        if (phone && phone.value) user.ph = phone.value.replace(/\D/g, '');

        if (!window.fbq) {
          !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
        }
        window.fbq('set', 'autoConfig', false, PIXEL_ID);
        window.fbq('init', PIXEL_ID, user);
        window.fbq('trackSingleCustom', PIXEL_ID, 'CorporateLead', {
          content_name: 'Corporate Gifting',
          form_location: this.formLocation,
        });
      } catch (e) {}
    }

    async onSubmit(event) {
      event.preventDefault();
      this.clearError();

      if (!this.form.checkValidity()) {
        this.form.reportValidity();
        return;
      }

      const formData = new FormData(this.form);
      const payload = {};
      formData.forEach(function (value, key) {
        payload[key] = value;
      });

      this.setBusy(true);
      try {
        const res = await fetch(this.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        const data = await res.json().catch(function () {
          return {};
        });

        if (res.ok && data && data.ok) {
          this.onSuccess();
        } else if (res.status === 400) {
          this.showError(this.dataset.errorInvalid);
        } else {
          this.showError(this.dataset.errorGeneric);
        }
      } catch (err) {
        this.showError(this.dataset.errorNetwork);
      } finally {
        this.setBusy(false);
      }
    }

    onSuccess() {
      this.fireConversion();
      if (this.successBox) this.successBox.hidden = false;
      this.form.hidden = true;

      /* The page section drops its heading once submitted; the modal listens for
         the event to resize itself around the shorter success panel. */
      const section = this.closest('.wholesale-form');
      if (section) section.classList.add('is-submitted');
      this.dispatchEvent(new CustomEvent('lead-form:success', { bubbles: true }));
    }
  }

  customElements.define('wholesale-lead-form', WholesaleLeadForm);
}
